module.exports = __webpack_public_path__ + "img/logo.e2376bb0.svg";